import t from 'tcomb-form'

const RowCount = t.refinement(t.Number, n => n >= 0 && n <= 10)
const Airports = t.refinement(t.String, airports => {
    const reg = /^(\s*[a-zA-Z]{3,4}\s*)(,\s*[a-zA-Z]{3,4}\s*)*$/
    return reg.test(airports)
})

const weatherFormModel = {
    types: t.struct({}),
    airports: Airports,
    count: RowCount,
}

export default weatherFormModel


// WEBPACK FOOTER //
// ./src/screens/weather/components/WeatherForm/model.js